import '@babel/polyfill';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { App, initIcons } from './components';
import { Provider } from 'react-redux';
import { createReduxStore, DUMPERT_STATE } from './store';
import { detectDevice } from './device';
import { createHistory } from './history';


detectDevice();
initIcons({ autoAddCss: false });

const store = createReduxStore(window[DUMPERT_STATE]);
const history = createHistory(store);

ReactDOM.hydrate(
  React.createElement(Provider, { store },
    React.createElement(Router, { history },
      React.createElement(App, { history }),
    ),
  ),
  document.getElementById('app'),
);
